module.exports = __webpack_public_path__ + "media/application/images/2018/my-consumer-accordian@2x-9bcf25b52db9ae247fc32ebe4c2389ac.png";